import { Group, Stack, Text } from "@mantine/core"
import { CountryLabel } from "@tfg/ui"

import { useFindProductionSiteById } from "~/gen/api"
import { COUNTRIES } from "~/utils/countries.ts"
import { formatAddress } from "~/utils/format-address"

export function ProductionSiteDisplay({
  productionSiteId,
}: {
  productionSiteId: string
}) {
  const { data: productionSite } = useFindProductionSiteById(productionSiteId)
  return (
    <Group justify="space-between">
      {productionSite ? (
        <Stack gap={0}>
          <Text fw={700}>{productionSite.data.name}</Text>
          {productionSite.data.countryIso3166 && (
            <Group gap="xs">
              <CountryLabel
                countryIso3166={productionSite.data.countryIso3166}
                width={12}
                countriesMapper={COUNTRIES}
              />
              <Text fz="xs">{formatAddress({
                street: productionSite.data.street,
                postalCode: productionSite.data.postalCode,
                city: productionSite.data.city,
                country: productionSite.data.countryIso3166,
                rawAddress: productionSite.data.rawAddress,
              })}</Text>
            </Group>
          )}
        </Stack>
      ) : null}
    </Group>
  )
}
